import { Component, OnDestroy, OnInit } from "@angular/core";
import { IntegratedAdmissionWizardService } from "../../service/integrated-admission-wizard.service";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { MedicalOrderScann } from "src/app/model/medical-order-scann";
import { Subscription } from "rxjs";
import { MedicalOrderProcedureExtraction } from "src/app/model/medical-order-procedure-extraction/medical-order-procedure-extraction";
import { MedicalOrderProcedureExtractionComponent } from "src/app/components/dialogs/medical-order-procedure-extraction/medical-order-procedure-extraction.component";
import { MatDialog } from "@angular/material";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-integrated-admission-appointment-scann",
  templateUrl: "./integrated-admission-appointment-scann.component.html",
  styleUrls: ["./integrated-admission-appointment-scann.component.css"],
})
export class IntegratedAdmissionAppointmentScannComponent
  implements OnInit, OnDestroy
{
  appointment: IntegratedAdmissionAppointment;
  scanns: MedicalOrderScann[] = [];
  currentAppointmentSubscription: Subscription;
  readonlySubscription: Subscription;
  readonly = false;

  constructor(
    private authService: AuthService,
    private service: IntegratedAdmissionWizardService,
    public dialog: MatDialog
  ) {}

  ngOnDestroy(): void {
    if (this.currentAppointmentSubscription)
      this.currentAppointmentSubscription.unsubscribe();

    if (this.readonlySubscription) this.readonlySubscription.unsubscribe();
  }

  get canExtractProcedures(): boolean {
    if (
      (this.service.canExtractProcedures() || (this.appointment && this.appointment.Appointment && this.appointment.Appointment.Id <= 0)) &&
      this.authService.enabledIA() &&
      this.appointment &&
      this.appointment.Plan
    ) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {
    this.readonlySubscription = this.service.currentReadOnlySubject$.subscribe(
      (readonly) => {
        this.readonly = readonly;
      }
    );

    this.currentAppointmentSubscription =
      this.service.currentAdmissionAppointment$.subscribe((appointment) => {
        if (appointment) {
          this.appointment = null;
          setTimeout(() => {
            this.appointment = appointment;
            this.scanns = [...appointment.Scanns];
          }, 500);
        }
      });
  }

  async onMecicalOrderSelected(base64: string) {
    if (!this.appointment.Plan.Plan) {
      this.service.notificationToastService.error(
        "Debe seleccionar un plan para el procedimiento",
        "Admisión"
      );
      return;
    }

    if (!this.appointment.Plan.AliquotTax) {
      this.service.notificationToastService.error(
        "Debe seleccionar una alícuota",
        "Admisión"
      );
      return false;
    }

    const dialogRef = this.dialog.open(
      MedicalOrderProcedureExtractionComponent,
      {
        width: "90vw",
        height: "90vh",
         panelClass: 'full-dialog',
        data: {
          service: this.service,
          fileBase64: base64,
          planId: this.appointment.Plan.Plan.Id,
          physicianId: this.appointment.Appointment.PhysicianId,
          centerId: this.service.centerId,
          equipmentId: this.appointment.Appointment.EquipmentId,
        },
      }
    );
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result && result.length > 0) {
         await this.service.reloadProcedures();
        for (const procedure of result) {
          await this.service.setProcedureIdSelected(
            procedure.PracticeRegion.Id,
            procedure.IsManualAdded ? false : true
          );
        }
      }
    });
  }

  onMecicalOrderScannChange(scanns: MedicalOrderScann[]) {
    this.service.setScanns(scanns);
  }
}
